import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, array, boolean, mixed, object, string } from "yup";
import "Forms/Schemas/customMethods";

export type FinancialProductExpenseCustomItem = {
  expenseItemID?: string | null;
  type?: string;
  installment?: string;
  balance?: string;
  institution?: string;
  belongsTo?: string;
  relatedAssetItemID?: string | null;
  id?: string | null;
};

export type FinancialProductExpenseFormType = {
  readonly aggregatedAmount?: string;
  readonly detailed?: boolean;
  readonly customItems?: FinancialProductExpenseCustomItem[];
};

export const getFinancialProductExpenseFormSchema = (
  t: (path: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
): ObjectSchema<FinancialProductExpenseFormType> => {
  const customItemSchema = object({
    id: string().nullable().notRequired(),
    expenseItemID: string().nullable().notRequired(),
    type: string().required(t(Resources.Validation.Required)),
    installment: string().required(t(Resources.Validation.Required)),
    balance: string().optional(),
    institution: string().optional(),
    belongsTo: string().optional(),
    relatedAssetItemID: string().nullable().notRequired(),
  });

  return object({
    detailed: boolean().optional(),

    aggregatedAmount: string().when(["detailed"], ([detailed], schema) =>
      !detailed
        ? schema.required(t(Resources.Validation.Required)).greaterThanZero(t(Resources.Validation.Number.MoreThen, { count: 0 }))
        : schema.optional(),
    ),

    customItems: array().when(["detailed"], ([detailed], schema) => {
      return detailed ? schema.of(customItemSchema).optional() : mixed().notRequired();
    }),
  }).defined();
};
